import { create } from 'zustand';

const VIP_HEADER_DISMISSED_KEY = 'vip-header-button-dismissed';

const readHeaderDismissed = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(VIP_HEADER_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
};

const writeHeaderDismissed = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(VIP_HEADER_DISMISSED_KEY, '1');
  } catch {
    // ignore storage errors (private mode / quota)
  }
};

type VipModalState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  /**
   * Once the user messages the VIP manager, the header-bar entry is hidden
   * for good. Mirrored to localStorage and kept reactive via the store.
   */
  headerButtonDismissed: boolean;
  hydrateHeaderDismissed: () => void;
  dismissHeaderButton: () => void;
};

export const useVipModalStore = create<VipModalState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  headerButtonDismissed: false,
  hydrateHeaderDismissed: () =>
    set({ headerButtonDismissed: readHeaderDismissed() }),
  dismissHeaderButton: () => {
    writeHeaderDismissed();
    set({ headerButtonDismissed: true });
  },
}));
